import { useState, useCallback } from 'react';
import { APPRAISAL_STORAGE_KEYS } from 'site-modules/shared/components/appraisal/trade-in-appraiser-steps/license-plate-and-vin-step/constants';
import { LP_ERROR_KEYS } from 'site-modules/shared/components/appraisal/appraisal-tabs-v2/constants/license-plate-constants';
import { readStoredLicensePlate } from 'site-modules/shared/components/appraisal/appraisal-tabs-v2/utils/read-stored-license-plate';

export function useLicensePlateFields({ storage, clearFieldError }) {
  const [licensePlateInputValue, setLicensePlateInputValue] = useState(() => {
    if (!storage) return '';
    return readStoredLicensePlate(storage) || '';
  });
  const [stateCodeInputValue, setStateCodeInputValue] = useState(() => {
    if (!storage) return '';
    return storage.get(APPRAISAL_STORAGE_KEYS.STATE_CODE) || '';
  });

  const onLicensePlateChange = useCallback(
    e => {
      const value = e.target.value;
      setLicensePlateInputValue(value);
      clearFieldError(LP_ERROR_KEYS.LICENSE_PLATE);
      if (storage) {
        storage.set(APPRAISAL_STORAGE_KEYS.LICENSE_PLATE, value);
      }
    },
    [clearFieldError, storage]
  );

  const onStateCodeChange = useCallback(
    option => {
      const value = option.stateCode;
      setStateCodeInputValue(value);
      clearFieldError(LP_ERROR_KEYS.STATE_CODE);
      if (storage) {
        storage.set(APPRAISAL_STORAGE_KEYS.STATE_CODE, value);
      }
    },
    [clearFieldError, storage]
  );

  return { licensePlateInputValue, stateCodeInputValue, onLicensePlateChange, onStateCodeChange };
}
